import FormService from "@/services/FormService.js";

export default {
  data() {
    return {
      formQuestions: [],
      gettingFormQuestions: false,
    };
  },
  computed: {
    columns() {
      return [
        { label: "Submitter Email", value: "email" },
        ...this.formQuestions.map((question) => ({
          label: question.label,
          value: question.formQuestionId,
        })),
      ];
    },
  },
  methods: {
    async getColumnsFromForm(formId) {
      this.gettingFormQuestions = true;
      const response = await FormService.getFormsByIdV2(formId, undefined, {
        includeQuestions: true,
      });
      this.formQuestions = response.result.FormQuestions.filter(
        (question) => question.type !== "group" && question.type !== "additional-claimants"
      );
      this.gettingFormQuestions = false;
      return this.columns;
    },
  },
};
